import React, { useState } from 'react';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';

const LayoutSetup = () => {
  const toast = React.useRef(null);
  const [layoutSettings, setLayoutSettings] = useState({
    headerLayout: 'default',
    footerLayout: 'default',
    sidebarPosition: 'left',
    contentWidth: 'full',
  });

  const headerLayoutOptions = [
    { label: 'Default', value: 'default' },
    { label: 'Centered', value: 'centered' },
    { label: 'Full Width', value: 'full-width' },
  ];

  const footerLayoutOptions = [
    { label: 'Default', value: 'default' },
    { label: 'Minimal', value: 'minimal' },
    { label: 'Extended', value: 'extended' },
  ];

  const sidebarPositionOptions = [
    { label: 'Left', value: 'left' },
    { label: 'Right', value: 'right' },
    { label: 'None', value: 'none' },
  ];

  const contentWidthOptions = [
    { label: 'Full Width', value: 'full' },
    { label: 'Boxed', value: 'boxed' },
    { label: 'Wide', value: 'wide' },
  ];

  const handleSave = () => {
    // Add your save logic here
    toast.current.show({
      severity: 'success',
      summary: 'Success',
      detail: 'Layout settings saved successfully',
      life: 3000,
    });
  };

  const handleReset = () => {
    setLayoutSettings({
      headerLayout: 'default',
      footerLayout: 'default',
      sidebarPosition: 'left',
      contentWidth: 'full',
    });
    toast.current.show({
      severity: 'info',
      summary: 'Reset',
      detail: 'Layout settings reset to default',
      life: 3000,
    });
  };

  return (
    <div className="p-4">
      <Toast ref={toast} />

      <div className="mb-4">
        <h2 className="text-2xl font-bold text-gray-800 mb-2">Layout Setup</h2>
        <p className="text-gray-600">Configure your website's layout settings</p>
      </div>

      <Card className="mb-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

          {/* Header Layout */}
          <div className="flex flex-col gap-2">
            <label htmlFor="headerLayout" className="font-semibold text-gray-700">
              Header Layout
            </label>
            <Dropdown
              id="headerLayout"
              value={layoutSettings.headerLayout}
              options={headerLayoutOptions}
              onChange={(e) => setLayoutSettings({ ...layoutSettings, headerLayout: e.value })}
              className="w-full"
              placeholder="Select Header Layout"
            />
          </div>

          {/* Footer Layout */}
          <div className="flex flex-col gap-2">
            <label htmlFor="footerLayout" className="font-semibold text-gray-700">
              Footer Layout
            </label>
            <Dropdown
              id="footerLayout"
              value={layoutSettings.footerLayout}
              options={footerLayoutOptions}
              onChange={(e) => setLayoutSettings({ ...layoutSettings, footerLayout: e.value })}
              className="w-full"
              placeholder="Select Footer Layout"
            />
          </div>

          {/* Sidebar Position */}
          <div className="flex flex-col gap-2">
            <label htmlFor="sidebarPosition" className="font-semibold text-gray-700">
              Sidebar Position
            </label>
            <Dropdown
              id="sidebarPosition"
              value={layoutSettings.sidebarPosition}
              options={sidebarPositionOptions}
              onChange={(e) => setLayoutSettings({ ...layoutSettings, sidebarPosition: e.value })}
              className="w-full"
              placeholder="Select Sidebar Position"
            />
          </div>

          {/* Content Width */}
          <div className="flex flex-col gap-2">
            <label htmlFor="contentWidth" className="font-semibold text-gray-700">
              Content Width
            </label>
            <Dropdown
              id="contentWidth"
              value={layoutSettings.contentWidth}
              options={contentWidthOptions}
              onChange={(e) => setLayoutSettings({ ...layoutSettings, contentWidth: e.value })}
              className="w-full"
              placeholder="Select Content Width"
            />
          </div>

        </div>
      </Card>

      {/* Action Buttons */}
      <div className="flex gap-3 justify-end">
        <Button
          label="Reset"
          icon="pi pi-refresh"
          className="p-button-secondary"
          onClick={handleReset}
        />
        <Button
          label="Save Changes"
          icon="pi pi-check"
          className="p-button-primary"
          onClick={handleSave}
        />
      </div>
    </div>
  );
};

export default LayoutSetup;
